import { Grid, Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { Fragment } from "react";
import { Title } from "./Title";
import type { Addresses as AddressesType } from "./types";

export type AddressProps = {
  addresses: AddressesType;
};

export const Addresses = (props: AddressProps) => {
  const { addresses } = props;
  const classes = classNames("mobius-footer__addresses", {
    "--is-single": addresses?.length === 1,
  });

  if (!addresses) {
    console.warn("Addresses will not render. Prop addresses is empty.");
    return null;
  }

  return (
    <div className={classes}>
      <div>
        <Title>Address</Title>
        <Grid columns={addresses.length} columnGap="sm">
          {addresses.map(entry => (
            <Text
              key={entry[0]}
              variant="small"
              className="mobius-footer__address-entry"
            >
              <span itemProp="address">
                {entry.map(item => (
                  <Fragment key={item}>
                    {item}
                    <br />
                  </Fragment>
                ))}
              </span>
            </Text>
          ))}
        </Grid>
      </div>
    </div>
  );
};
